import {ProcessElementProps} from "./ProcessElementProps";

export class ProcessLaneProps extends ProcessElementProps {
	constructor(processEditor, fieldPath, obj, member) {
		super(processEditor, fieldPath, obj, member);
	}

	rebuild() {
		super.rebuild();
	}
}